import React from "react"
import { BrowserRouter, Link, Route, Switch } from "react-router-dom"
import "./App.css"

import Calendar from "./Calendar/Calendar"
import Home from "./Home/Home"
import Menu from "./Menu/Menu"
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy"
import Marquee from "./Marquee/Marquee"
import AboutUs from "./AboutUs/AboutUs"
import AllAccess from "./AllAccess/AllAccess"
import StudentSeminar from "./StudentSeminar/StudentSeminar"

const App = () => {
  return (
    <BrowserRouter>
      <div className="AppShell App">
        <header className="AppHeader">
          <div className="AppHeaderCenter">
            <Link to="/" className="BrandLink">
              <h1 className="BrandTitle">The Broadway Maven</h1>
            </Link>

            <Menu />
          </div>
        </header>

        <main className="AppMain">
          <Switch>
            <Route exact path="/calendar" component={Calendar} />
            <Route exact path="/privacypolicy" component={PrivacyPolicy} />
            <Route exact path="/marquee" component={Marquee} />
            <Route exact path="/" component={Home} />
            <Route exact path="/about-us" component={AboutUs} />
            <Route exact path="/all-access" component={AllAccess} />
            <Route exact path="/studentseminar" component={StudentSeminar} />
          </Switch>
        </main>

        <footer className="AppFooter">
          <Link className="FooterLink" to="/privacypolicy">
            Privacy Policy
          </Link>
        </footer>
      </div>
    </BrowserRouter>
  )
}

export default App
